// @ts-check
/**
 * @prettier
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ButtonV2, CTAV2 } from '@zola/zola-ui';

import SingleDraft from './components/SingleDraft';
import MultipleDrafts from './components/MultipleDrafts';

import { getStepUrl } from '../../../../util/getStepUrl';

// @ts-ignore
import styles from './ExistingDraftsForCardSuiteModal.module.less';

/**
 * @param {number} draftAmount
 * @param {string} cardSuiteName
 * @return {string} Title
 */
const generateTitle = (draftAmount, cardSuiteName) =>
  `You already have ${draftAmount > 1 ? `${draftAmount} drafts` : ' a draft'} in ${cardSuiteName}`;

/**
 * @param {Object} props - Component props
 * @param {Array} props.relatedDrafts - Related drafts for this item
 * @param {() => void} props.onStartNewProject - On start new project callback
 */
const ExistingDraftsForCardSuiteModal = ({ relatedDrafts, onStartNewProject }) => {
  const [selectedItemUUID, setSelectedItemUUID] = useState(relatedDrafts[0].project_uuid);
  const titleClasses = cx(styles.title, { [styles.single]: relatedDrafts.length === 1 });
  return (
    <div className={styles.modal}>
      <div className={styles.body}>
        <h3 className={titleClasses}>
          {generateTitle(relatedDrafts.length, relatedDrafts[0].project_name)}
        </h3>
        {relatedDrafts.length === 1 ? (
          <SingleDraft draft={relatedDrafts[0]} />
        ) : (
          <MultipleDrafts
            drafts={relatedDrafts}
            selectedItemUUID={selectedItemUUID}
            onSelectionChanged={uuid => setSelectedItemUUID(uuid)}
          />
        )}
        <div className={styles.actions}>
          <CTAV2
            className={styles.cta}
            arrow={false}
            component="button"
            // @ts-ignore
            variant="secondary"
            onClick={onStartNewProject}
          >
            Start New
          </CTAV2>
          <div className={styles.separator} />
          <ButtonV2 component="a" href={getStepUrl(selectedItemUUID)}>
            Edit Draft
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};

ExistingDraftsForCardSuiteModal.propTypes = {
  relatedDrafts: PropTypes.arrayOf(
    PropTypes.shape({
      project_name: PropTypes.string,
      project_uuid: PropTypes.string,
    })
  ),
  onStartNewProject: PropTypes.func,
};

export default ExistingDraftsForCardSuiteModal;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/ExistingDraftsForCardSuiteModal/ExistingDraftsForCardSuiteModal.jsx